import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import CreateApp from './pages/CreateApp';
import ProjectView from './pages/ProjectView';
import ProfilePage from './pages/ProfilePage';
import TrendingPage from './pages/TrendingPage';
import StorePage from './pages/StorePage';
import DisplayApp from './pages/DisplayApp';
import PublicProfilePage from './pages/PublicProfilePage';
import './App.css';

import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="app">
          <Navbar />
          <Routes>
  <Route path="/" element={<HomePage />} />
  <Route path="/create" element={<CreateApp />} />
  <Route path="/profile" element={<ProfilePage />} /> {/* Keep only one of these */}
  <Route path="/project/:projectId" element={<ProjectView />} />
  <Route path="/trending" element={<TrendingPage />} />
  <Route path="/store" element={<StorePage />} />
  <Route path="/display/:projectId" element={<DisplayApp />} />
  <Route path="/user/:username" element={<PublicProfilePage />} />
</Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;